import SilAccommodationSettingsContainer from "./SilAccommodationSettings.container";
export default SilAccommodationSettingsContainer;
